import { Box, Card, CardMedia, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { FunctionComponent } from "react";
import treeFieldImage from '../../../assets/cover-images/tree-field.jpg';
import mountainRoadImage from '../../../assets/cover-images/mountain-road.jpg';
import aerialForestImage from '../../../assets/cover-images/aerial-forest.jpg';
import goldenForestImage from '../../../assets/cover-images/golden-forest.jpg';
import lakeSunsetImage from '../../../assets/cover-images/lake-sunset.jpg';

export const GaiaWebPageCoverImageDialog: FunctionComponent<{
  open: boolean,
  selectDefaultImage: (imageUrl: string) => void,
  setShowDefaultImages: React.Dispatch<React.SetStateAction<boolean>>,
}> = ({
  open,
  selectDefaultImage,
  setShowDefaultImages,
}) => {

    const defaultImages = [
      {
        id: 1,
        name: 'Tree in Field',
        url: treeFieldImage,
        description: ''
      },
      {
        id: 2,
        name: 'Mountain Road',
        url: mountainRoadImage,
        description: ''
      },
      {
        id: 3,
        name: 'Aerial Forest',
        url: aerialForestImage,
        description: ''
      },
      {
        id: 4,
        name: 'Golden Forest',
        url: goldenForestImage,
        description: ''
      },
      {
        id: 5,
        name: 'Lake Sunset',
        url: lakeSunsetImage,
        description: ''
      }
    ];


    return (
      <Dialog open={open} onClose={() => setShowDefaultImages(false)} maxWidth='xs'>
        <Box sx={{ p: 4 }}>
          <DialogTitle sx={{ pt: 0, pl: 0, pr: 0 }}>
            Select Cover Image
          </DialogTitle>
          <DialogContent sx={{ pt: 0, pl: 0, pr: 0 }}>
            <Grid container spacing={2}>
              {defaultImages.map((image) => (
                <Grid item xs={12} sm={6} md={4} key={image.id}>
                  <Card
                    sx={{
                      cursor: 'pointer',
                      boxShadow: 'none',
                      '&:hover': {
                        transform: 'scale(1.02)',
                        transition: 'all 0.2s ease-in-out'
                      }
                    }}
                    onClick={() => selectDefaultImage(image.url)}
                  >
                    <CardMedia
                      component="img"
                      height="140"
                      image={image.url}
                      alt={image.name}
                      sx={{ objectFit: 'cover' }}
                    />
                  </Card>
                </Grid>
              ))}
            </Grid>
          </DialogContent>
        </Box>
      </Dialog>
    )
  }